import React from 'react';
import {
  TableContainer,
  TableHead,
  TableBody,
  TableBodyRow,
} from '../../../../../../../components/tableComponents';

export const accountsTableComponents = {
  table: TableContainer,
  header: {
    wrapper: TableHead,
  },
  body: {
    wrapper: TableBody,
    row: (props) => <TableBodyRow {...props} />,
  },
};
